module.exports = __webpack_public_path__ + "img/Jata_Logo.063dfa12.png";